<div>
  <mat-toolbar class="app-content" color="primary" style="padding: 0 16px;">
    <mat-toolbar-row>
    <div>
      <div style="font-size:10px; position:absolute; top:0px; left:21px;">{{ 'menue.#' | translate:locale.language }}</div>
      <button style="position:absolute; top:12px; left:16px;" mat-icon-button (click)="toggleSidenav()">
        <mat-icon id="menuicon" class="mat-24" >menu</mat-icon>
      </button>
    </div>
    <div class="app-toolbar" style="position: absolute; width: calc(100% - 72px); left:56px; top: 12px">
      <h1><a mat-button routerLink="/">{{ 'project.title' | translate:locale.language }}</a></h1>
      <span class="fill-remaining-space"></span>
      <button id="benutzermenu" mat-icon-button [matMenuTriggerFor]="benutzermenu" *ngIf="isAuth()" [matTooltip]="authService.getUserfullname()"><img class="userimgsmall" [src]="authService.getUserimage()" alt="Avatar"></button>
      <button id="logout" mat-icon-button (click)="onLogout()" *ngIf="isAuth()" matTooltip="{{ 'header.logout' | translate:locale.language }}"><mat-icon class="mat-24" >power_settings_new</mat-icon></button>
    </div>
    <div *ngIf="lieferant" style="font-size:12px; position:absolute; left:72px; top:35px;">
        <span>{{ lieferant.liefernummer }} | </span>
        <span>{{ authService.getUserfullname() }} | </span>
        <span>{{ lieferant.strasse }} | </span>
        <span>{{ lieferant.plz }}-{{ lieferant.ort }}</span>
    </div>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <span class="fill-remaining-space"></span>
      <span class="version">{{ appVersion }}</span>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
<mat-progress-bar [color]="sessionTimeoutColor" [value]="sessionLeftTime * 100 / sessionMaxTime" class="sessiontimeout"></mat-progress-bar>

<mat-menu #benutzermenu="matMenu" class="benutzermenu">
  <div class="usercont">
    <div class="userinfo">
      <div class="userfullname center">{{ authService.getUserfullname() }}</div>
      <div class="usermail center">{{ authService.getUseremail() }}</div>
    </div>
  </div>
  <hr />
  <button mat-menu-item (click)="zeigePasswortMaske()">
    <mat-icon>security</mat-icon>
    <span>{{ 'benutzer.passwort_ändern' | translate:locale.language }}</span>
  </button>
</mat-menu>

